import { render, staticRenderFns } from "./SsoOptions.vue?vue&type=template&id=10245921"
import script from "./SsoOptions.vue?vue&type=script&lang=js"
export * from "./SsoOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports